import _ from "lodash";
import { ROLE, UAA_CHILDREN_PATH } from "./constant";
export const menus = [
  {
    name: "menu.uaa.channel_management",
    type: "group",
    roles: [
      ROLE.HO_MOSAN_BUSINIESS,
      ROLE.HO_MOSAN_FINANCE_REVIEWER,
      ROLE.HO_MOSAN_FINANCE_BO,
      ROLE.HO_MOSAN_FINANCE_STAFF,
      ROLE.SA_COMPANY_STAFF,
      ROLE.SA_COMPANY_REVIEWER,
      ROLE.SA_COMPANY_BO,
      ROLE.BRANCH_STAFF,
      ROLE.BRANCH_REVIEWER,
      ROLE.BRANCH_BO,
      ROLE.SA_EXTERNAL_STAFF,
      ROLE.SA_EXTERNAL_REVIEWER,
      ROLE.SA_EXTERNAL_BO,
    ],
    children: [
      {
        name: "menu.uaa.overview",
        path: UAA_CHILDREN_PATH.OVERVIEW,
        roles: [
          ROLE.HO_MOSAN_BUSINIESS,
          ROLE.HO_MOSAN_FINANCE_REVIEWER,
          ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.HO_MOSAN_FINANCE_STAFF,
          ROLE.SA_COMPANY_STAFF,
          ROLE.SA_COMPANY_REVIEWER,
          ROLE.SA_COMPANY_BO,
          ROLE.BRANCH_STAFF,
          ROLE.BRANCH_REVIEWER,
          ROLE.BRANCH_BO,
          ROLE.SA_EXTERNAL_STAFF,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
        ],
      },

      {
        name: "menu.uaa.register_create_request",
        path: UAA_CHILDREN_PATH.REGISTER_CREATE_REQUEST,
        roles: [
          ROLE.HO_MOSAN_BUSINIESS,
          ROLE.HO_MOSAN_FINANCE_STAFF,
          // ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.SA_COMPANY_STAFF,
          ROLE.BRANCH_STAFF,
          ROLE.SA_EXTERNAL_STAFF,
        ],
      },
      {
        name: "menu.uaa.register_approve_request",
        path: UAA_CHILDREN_PATH.REGISTER_APPROVE_REQUEST,
        roles: [
          ROLE.HO_MOSAN_BUSINIESS,
          ROLE.HO_MOSAN_FINANCE_REVIEWER,
          ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.SA_COMPANY_REVIEWER,
          ROLE.SA_COMPANY_BO,
          ROLE.BRANCH_REVIEWER,
          ROLE.BRANCH_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
        ],
      },

      {
        name: "menu.uaa.update_approve_request",
        path: UAA_CHILDREN_PATH.UPDATE_APPROVE_REQUEST,
        roles: [
          ROLE.HO_MOSAN_BUSINIESS,
          ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.HO_MOSAN_FINANCE_REVIEWER,
          ROLE.SA_COMPANY_REVIEWER,
          ROLE.SA_COMPANY_BO,
          ROLE.BRANCH_REVIEWER,
          ROLE.BRANCH_BO,
          ROLE.SA_EXTERNAL_REVIEWER,
          ROLE.SA_EXTERNAL_BO,
        ],
      },
      {
        name: "menu.uaa.manage_sys_user",
        path: UAA_CHILDREN_PATH.MANAGE_SYS_USER_LIST,
        roles: [
          ROLE.HO_MOSAN_BUSINIESS,
          ROLE.HO_MOSAN_FINANCE_REVIEWER,
          ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.HO_MOSAN_FINANCE_STAFF,
        ],
      },
    ],
  },
  {
    name: "menu.uaa.report",
    type: "group",
    roles: [],
    children: [
      {
        name: "menu.uaa.report_channel",
        path: UAA_CHILDREN_PATH.REPORT_CHANNEL,
      },
      {
        name: "menu.uaa.report_total_debit",
        path: UAA_CHILDREN_PATH.REPORT_TOTAL_DEBIT,
      },
      {
        name: "menu.uaa.report_detail_debit",
        path: UAA_CHILDREN_PATH.REPORT_DETAIL_DEBIT,
      },
    ],
  },
  {
    name: "menu.uaa.funding_management",
    type: "group",
    roles: [ROLE.HO_MOSAN_FINANCE_BO, ROLE.SA_COMPANY_BO, ROLE.SA_EXTERNAL_BO],
    children: [
      // {
      //   name: "Request Clear Debit for Channel",
      //   path: UAA_CHILDREN_PATH.REQUEST_CLEAR_DEBIT_CHANNEL,
      // },
      {
        name: "menu.uaa.approve_clear_debit",
        path: UAA_CHILDREN_PATH.APPROVE_REQUEST_CLEAR_DEBIT_CHANNEL,
        roles: [
          ROLE.HO_MOSAN_FINANCE_BO,
          ROLE.SA_COMPANY_BO,
          ROLE.SA_EXTERNAL_BO,
        ],
      },
      // {
      //   name: "Request Cash in for Agent/ SA /MA /Sale",
      //   path: UAA_CHILDREN_PATH.FUNDING_REQUEST_CASH,
      // },
      // {
      //   name: "Approve cash in for Agent/SA /MA /Sale",
      //   path: UAA_CHILDREN_PATH.FUNDING_APPROVE_CASH,
      // },
    ],
  },
  {
    name: "menu.uaa.user_account",
    type: "item",
    path: UAA_CHILDREN_PATH.USER_MANAGEMENT,
  },
  {
    name: "menu.uaa.create_system",
    type: "item",
    path: UAA_CHILDREN_PATH.SYSTEM_MANAGEMENT,
  },

  {
    name: "menu.uaa.api",
    type: "item",
    path: UAA_CHILDREN_PATH.API_MANAGEMENT,
  },
  {
    name: "menu.uaa.service",
    type: "item",
    path: UAA_CHILDREN_PATH.SERVICE,
  },
  {
    name: "menu.uaa.feature",
    type: "item",
    path: `${UAA_CHILDREN_PATH.FEATURE}`,
  },
  {
    name: "menu.uaa.permission_config",
    type: "item",
    path: UAA_CHILDREN_PATH.PERMISSION_CONFIG,
  },
];
// const roleCurrentStore = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

export const getMenuItemsByRoles = (output, menus, roleCurrent) => {
  const { code: key } = Object(roleCurrent) || {};
  if (!menus || menus.length <= 0) return _.omit({ ...output }, ["children"]);

  // const configReview = getDataSession(LOCAL_STORAGE, CONFIG_REVIEW);

  const menuFilter =
    menus
      ?.filter(
        (item) => _.isEmpty(item.roles) || item.roles.includes(key)
        // && item.showMenu === configReview) ||
        // !item.showMenu
      )
      .map((itemMenu) => {
        return getMenuItemsByRoles(
          { ...itemMenu, children: [] },
          itemMenu.children,
          roleCurrent
        );
      }) || [];

  return { ...output, children: menuFilter };
};
export const navigateConfigUAA = {
  bizzApp: "UAA",
  children: [
    {
      name: "menu.uaa.permission_config",
      type: "item",
      path: UAA_CHILDREN_PATH.PERMISSION_CONFIG,
    },
    {
      name: "menu.uaa.user_account",
      type: "item",
      path: UAA_CHILDREN_PATH.USER_MANAGEMENT,
    },
    {
      name: "menu.uaa.create_system",
      type: "item",
      path: UAA_CHILDREN_PATH.SYSTEM_MANAGEMENT,
    },
    // {
    //   name: "Thêm mới quyền cho công ty",
    //   type: "item",
    //   path: UAA_CHILDREN_PATH.COMPANY_PERMISSION,
    // },
    {
      name: "menu.uaa.api",
      type: "item",
      path: UAA_CHILDREN_PATH.API_MANAGEMENT,
    },
    {
      name: "menu.uaa.service",
      type: "item",
      path: UAA_CHILDREN_PATH.SERVICE,
    },
    {
      name: "menu.uaa.feature",
      type: "item",
      path: `${UAA_CHILDREN_PATH.FEATURE}`,
    },
    {
      name: "menu.uaa.configuration_menu",
      type: "item",
      path: `${UAA_CHILDREN_PATH.CONFIGURATION_MENU}`,
    },
    {
      name: "menu.uaa.config_display_system",
      type: "item",
      path: `${UAA_CHILDREN_PATH.CONFIG_DISPLAY_SYSTEM}`,
    },
    // {
    //   name: "menu.uaa.screen_dashboard",
    //   type: "item",
    //   path: `${UAA_CHILDREN_PATH.SCREEN_DASHBOARD}`,
    // },
  ],
};
